import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const UpdateModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const { onSuccess } = props; // 移除重复的 record 解构
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const statusList = [
    { value: "1", label: "Active" },
    { value: "2", label: "Inactive" },
  ];

  useImperativeHandle(ref, () => ({
    showModal: async (record) => {
      try {
        console.log("Modal opening...", record);
        form.resetFields();
        setVisible(true);
        if (record) {
          const formValues = {
            id: record.id,
            businessType: record.businessType,
            remark: record.remark,
             status: record.status != null ? String(record.status) : undefined,
          };
          form.setFieldsValue(formValues);
        }
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));
  // 修改用户信息提交
  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        id: values.id,
        businessType: values.businessType,
        remark: values.remark,
        status: values.status,
      };
      const response = await http.post(`${api.getApLicenseTypeUpdate}`, queryParams);
      if (response.code === "1") {
        message.success("User updated successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
        window.location.reload();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error(error.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
  return (
    <>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              Update Ap License
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        footer={
           <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>}
        centered
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="UpdateCronJobForm"
                onFinish={onFinishAdd}
                form={form}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
                <Form.Item name="businessType" label="Business Type">
                  <Input placeholder="Please enter Email Content" allowClear />
                </Form.Item>
                <Form.Item name="remark" label="Remark">
                  <Input placeholder="Please enter Email Content" allowClear />
                </Form.Item>

                <Form.Item name="status" label="status">
                  <Select
                    placeholder="Select status"
                    options={statusList}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="id" hidden>
                  <Input />
                </Form.Item>
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>

    </>
  );
});

export default UpdateModal;
